import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { SelectChangeEvent } from '@mui/material';

interface SubeventAireListProps {
  value: string;
  required?: boolean;
  disabled?: boolean;
  onChange: (event: SelectChangeEvent<string>) => void;
  errors?: boolean;
}

const subeventList = Object.freeze([
  {
    id: '5',
    value: 'Perdita cittadinanza italiana “ope legis” ',
  },
  {
    id: '6',
    value: 'Perdita cittadinanza italiana per naturalizzazione straniera',
  },
  {
    id: '7',
    value: 'Dichiarazione di rinuncia cittadinanza italiana',
  },
]);

const SubeventAireListComponent = ({
  onChange,
  disabled,
  required,
  value,
  errors,
}: SubeventAireListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={errors} id="subevent-label">
        {required ? 'Subevento perdita cittadinanza *' : 'ubevento perdita cittadinanza'}
      </InputLabel>
      <PmiSelect
        labelId="subevent-label"
        id="subevent"
        name="subevent"
        value={value}
        label={required ? 'Subevento perdita cittadinanza *' : 'Subevento perdita cittadinanza'}
        onChange={onChange}
        disabled={disabled}
        error={errors}
      >
        {subeventList
          ? subeventList.map((element: ItemVM) => (
              <MenuItem key={element.id} value={element.id}>
                {element.value}
              </MenuItem>
            ))
          : []}
      </PmiSelect>
    </PmiFormControl>
  );
};

SubeventAireListComponent.displayName = 'subevent aire list component';

const SubeventAireList = memo(SubeventAireListComponent);

export default SubeventAireList as typeof SubeventAireListComponent;
